// extracted by mini-css-extract-plugin
export default {"formCheck":"form_formCheck__y9Gq1"};